import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

// Temporary themed stand-in rendered by every route until its real page
// lands (CS-04 onwards).
const PagePlaceholder = ({ tagline, title, description }) => (
  <Container maxWidth="lg">
    <Box sx={{ py: 12, textAlign: 'center' }}>
      {tagline && <Chip label={tagline} color="primary" size="small" sx={{ mb: 2 }} />}
      <Typography variant="h3" component="h1" sx={{ color: 'surface.dark', fontWeight: 700, mb: 2 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body1" sx={{ color: 'surface.contrastText', maxWidth: 640, mx: 'auto' }}>
          {description}
        </Typography>
      )}
    </Box>
  </Container>
);

export default PagePlaceholder;
